import React from "react";
import { Button, PageSpinner, Icon } from "@nike/epic-react-ui";
import { 
    NikeDesignSystemProvider,
    TextFieldStyled,
    TextStyled
} from "@nike/nike-design-system-components";
import "./FfrStatus.css";

class FfrStatus extends React.Component {
    render() {
        const {
            showSpinner,
            ffrNumber,
            onFfrNumberChange,
            handleSearch,
            statusData,
            sourcePayload,
            processedPayload,
            errorMessage,
            handleDownloadSource,
            handleDownloadProcessed,
            handleViewLogs,
            logsLoading,
            dcValue
        } = this.props;

        const hasData = statusData && statusData.ffrNumber;

        return (
            <div className="ffr-status-container">
                <PageSpinner show={showSpinner} />

                {/* Search Header */}
                <NikeDesignSystemProvider>
                    <div className="ffr-status-header">
                        <TextFieldStyled
                            value={ffrNumber}
                            onChange={(event) => onFfrNumberChange(event.target.value)}
                            type="text"
                            placeholder="Enter FFR Number"
                            label="FFR Number"
                            className="ffr-search-input"
                            onKeyPress={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearch();
                                }
                            }}
                        />
                        {dcValue && (
                            <div className="dc-badge">
                                <Icon type="LocationOn" size="s" />
                                <span style={{ fontSize: '14px', fontWeight: '600' }}>
                                    DC: {dcValue}
                                </span>
                            </div>
                        )}
                        <Button
                            type="NikeApp"
                            className="ffr-search-button"
                            onClick={handleSearch}
                            disabled={!ffrNumber || ffrNumber.trim().length === 0}
                        >
                            <Icon type="Search" size="s" />
                            Search
                        </Button>
                    </div>
                </NikeDesignSystemProvider>

                {/* Error Message */}
                {errorMessage && (
                    <div className="error-message">
                        <Icon type="ErrorOutline" size="s" />
                        <NikeDesignSystemProvider>
                            <TextStyled appearance="body2 text-bold">
                                Error:
                            </TextStyled>
                            <TextStyled appearance="body2">
                                {errorMessage}
                            </TextStyled>
                        </NikeDesignSystemProvider>
                    </div>
                )}

                {/* Status Information */}
                {hasData && (
                    <div className="ffr-status-info">
                        <NikeDesignSystemProvider>
                            <TextStyled appearance="title3 text-bold" style={{ marginBottom: '16px' }}>
                                FFR Status Information
                            </TextStyled>
                        </NikeDesignSystemProvider>
                        <div className="status-info-table">
                            <div className="status-info-row">
                                <div className="status-info-cell">
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body2" style={{ color: '#757575', textTransform: 'uppercase', fontSize: '11px', fontWeight: '600' }}>
                                            FFR Number
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body1 text-bold" style={{ marginTop: '4px' }}>
                                            {statusData.ffrNumber}
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                </div>
                                <div className="status-info-cell">
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body2" style={{ color: '#757575', textTransform: 'uppercase', fontSize: '11px', fontWeight: '600' }}>
                                            Status
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                    <div className="status-cell-row" style={{ marginTop: '4px' }}>
                                        <span className={`status-badge ${
                                            statusData.statusCategory === 'SUCCESS' ? 'status-success' :
                                            statusData.statusCategory === 'FAILED' ? 'status-failed' :
                                            'status-processing'
                                        }`}>
                                            {statusData.status}
                                        </span>
                                        {(statusData.statusCategory === 'FAILED' ||
                                          ['CD_Failed', 'Failed', 'ValidationFailed'].includes(statusData.status)) && (
                                            <button
                                                className="ffr-view-logs-btn"
                                                onClick={handleViewLogs}
                                                disabled={logsLoading}
                                                title="Open error logs in Splunk"
                                            >
                                                <Icon type="Search" size="s" />
                                                {logsLoading ? 'Opening…' : 'View Logs'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                                <div className="status-info-cell">
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body2" style={{ color: '#757575', textTransform: 'uppercase', fontSize: '11px', fontWeight: '600' }}>
                                            DC Code
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body1 text-bold" style={{ marginTop: '4px' }}>
                                            {statusData.dcCode}
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                </div>
                                <div className="status-info-cell">
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body2" style={{ color: '#757575', textTransform: 'uppercase', fontSize: '11px', fontWeight: '600' }}>
                                            Event Date
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body1 text-bold" style={{ marginTop: '4px' }}>
                                            {statusData.eventDate ? new Date(statusData.eventDate).toLocaleString() : 'N/A'}
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                </div>
                                <div className="status-info-cell">
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body2" style={{ color: '#757575', textTransform: 'uppercase', fontSize: '11px', fontWeight: '600' }}>
                                            Consumer Sales Order
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body1 text-bold" style={{ marginTop: '4px' }}>
                                            {statusData.consumerSalesOrderNumber || 'N/A'}
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                </div>
                            </div>
                            <div className="status-info-row">
                                <div className="status-info-cell">
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body2" style={{ color: '#757575', textTransform: 'uppercase', fontSize: '11px', fontWeight: '600' }}>
                                            Source File
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                    <div className="file-availability" style={{ marginTop: '4px' }}>
                                        <Icon 
                                            type={statusData.sourceFile?.available ? "CheckCircle" : "ErrorOutline"}
                                            size="s"
                                            style={{ color: statusData.sourceFile?.available ? '#00C853' : '#9E9E9E' }}
                                        />
                                        <NikeDesignSystemProvider>
                                            <TextStyled appearance="body2" style={{ color: statusData.sourceFile?.available ? '#111' : '#757575' }}>
                                                {statusData.sourceFile?.fileName || 'N/A'}
                                            </TextStyled>
                                        </NikeDesignSystemProvider>
                                    </div>
                                </div>
                                <div className="status-info-cell">
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body2" style={{ color: '#757575', textTransform: 'uppercase', fontSize: '11px', fontWeight: '600' }}>
                                            Processed File
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                    <div className="file-availability" style={{ marginTop: '4px' }}>
                                        <Icon 
                                            type={statusData.processedFile?.available ? "CheckCircle" : "ErrorOutline"}
                                            size="s"
                                            style={{ color: statusData.processedFile?.available ? '#00C853' : '#9E9E9E' }}
                                        />
                                        <NikeDesignSystemProvider>
                                            <TextStyled appearance="body2" style={{ color: statusData.processedFile?.available ? '#111' : '#757575' }}>
                                                {statusData.processedFile?.fileName || 'N/A'}
                                            </TextStyled>
                                        </NikeDesignSystemProvider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Payload Comparison - Side by Side */}
                {hasData && (
                    <div className="payload-comparison-container">
                        {/* Source Payload */}
                        <div className="payload-panel">
                            <div className="payload-header">
                                <div className="payload-title">
                                    <Icon type="FileOutline" size="s" />
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body1 text-bold">
                                            Source Payload
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                </div>
                                {statusData.sourceFile?.available && (
                                    <Button
                                        type="NikeApp"
                                        size="small"
                                        className="download-button"
                                        onClick={handleDownloadSource}
                                        disabled={!sourcePayload}
                                    >
                                        <Icon type="Download" size="s" />
                                        Download
                                    </Button>
                                )}
                            </div>
                            <div className="payload-content">
                                {sourcePayload ? (
                                    <pre className="payload-json">
                                        {JSON.stringify(sourcePayload, null, 2)}
                                    </pre>
                                ) : statusData.sourceFile?.available ? (
                                    <div className="payload-empty">
                                        <Icon type="InfoOutline" size="m" />
                                        <NikeDesignSystemProvider>
                                            <TextStyled appearance="body2" style={{ color: '#757575' }}>
                                                Click "Search" to load payload
                                            </TextStyled>
                                        </NikeDesignSystemProvider>
                                    </div>
                                ) : (
                                    <div className="payload-empty">
                                        <Icon type="ErrorOutline" size="m" />
                                        <NikeDesignSystemProvider>
                                            <TextStyled appearance="body2" style={{ color: '#9E9E9E' }}>
                                                Source file not available
                                            </TextStyled>
                                        </NikeDesignSystemProvider>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Processed Payload */}
                        <div className="payload-panel">
                            <div className="payload-header">
                                <div className="payload-title">
                                    <Icon type="FileCheckOutline" size="s" />
                                    <NikeDesignSystemProvider>
                                        <TextStyled appearance="body1 text-bold">
                                            Processed Payload
                                        </TextStyled>
                                    </NikeDesignSystemProvider>
                                </div>
                                {statusData.processedFile?.available && (
                                    <Button
                                        type="NikeApp"
                                        size="small"
                                        className="download-button"
                                        onClick={handleDownloadProcessed}
                                        disabled={!processedPayload}
                                    >
                                        <Icon type="Download" size="s" />
                                        Download
                                    </Button>
                                )}
                            </div>
                            <div className="payload-content">
                                {processedPayload ? (
                                    <pre className="payload-json">
                                        {JSON.stringify(processedPayload, null, 2)}
                                    </pre>
                                ) : statusData.processedFile?.available ? (
                                    <div className="payload-empty">
                                        <Icon type="InfoOutline" size="m" />
                                        <NikeDesignSystemProvider>
                                            <TextStyled appearance="body2" style={{ color: '#757575' }}>
                                                Click "Search" to load payload
                                            </TextStyled>
                                        </NikeDesignSystemProvider>
                                    </div>
                                ) : (
                                    <div className="payload-empty">
                                        <Icon type="ErrorOutline" size="m" />
                                        <NikeDesignSystemProvider>
                                            <TextStyled appearance="body2" style={{ color: '#9E9E9E' }}>
                                                Processed file not available
                                            </TextStyled>
                                        </NikeDesignSystemProvider>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )}

                {/* No Data Message */}
                {!hasData && !errorMessage && (
                    <div className="no-data-message">
                        <Icon type="Search" size="l" style={{ color: '#BDBDBD' }} />
                        <NikeDesignSystemProvider>
                            <TextStyled appearance="body1" style={{ color: '#757575' }}>
                                Enter an FFR Number above and click Search to view status and payloads
                            </TextStyled>
                        </NikeDesignSystemProvider>
                    </div>
                )}
            </div>
        );
    }
}

export default FfrStatus;
